import { buildAPIUrl, responseInterceptor } from '.';

export interface Notification {
  msgId: string;
  subject: string;
  message: string;
  timestamp: string;
  read: boolean;
  isDeleted?: boolean;
}

export interface NotificationListResponse {
  success: boolean;
  result: Notification[];
}

export const listNotifications = async (): Promise<NotificationListResponse> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/notification/list`),
  );
  return response.json();
};

export const saveNotification = async (notification: Notification): Promise<{ success: boolean }> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/notification/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(notification),
    }),
  );
  return response.json();
};
